/**
 * Remove HTML code from a string
 * @param  {String} html Formatted HTML code
 * @return {String}      Plain text
 */
export default function stripHtml(html) {
    return html.replace(/(<([^>]+)>)/ig, "");
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/stripHtml.ts
// module id = OitI
// module chunks = 2